/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const VIDEO_ANALYTIC_STATUS_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:video analytic status.pending'); } },
  { value: 1, get label() { return i18n.t('constants:video analytic status.in_progress'); } },
  { value: 2, get label() { return i18n.t('constants:video analytic status.done'); } },
  { value: 3, get label() { return i18n.t('constants:video analytic status.restart'); } },
  { value: 4, get label() { return i18n.t('constants:video analytic status.failure'); } },
  { value: 5, get label() { return i18n.t('constants:video analytic status.stop'); } },
  { value: 6, get label() { return i18n.t('constants:video analytic status.unknown'); } },
  { value: 8, get label() { return i18n.t('constants:video analytic status.paused'); } },
]);

export const VIDEO_ANALYTIC_TYPES_OPTIONS_BASE = optionsProxy.create([
  { value: 'handsup', get label() { return i18n.t('constants:video analytic types.handsup'); } },
  { value: 'lying', get label() { return i18n.t('constants:video analytic types.lying'); } },
  { value: 'bag', get label() { return i18n.t('constants:video analytic types.bag'); } },
  { value: 'weapon', get label() { return i18n.t('constants:video analytic types.weapon'); } },
  { value: 'fire', get label() { return i18n.t('constants:video analytic types.fire'); } },
  { value: 'fight', get label() { return i18n.t('constants:video analytic types.fight'); } },
  { value: 'crowd', get label() { return i18n.t('constants:video analytic types.crowd'); } },
  { value: 'fall', get label() { return i18n.t('constants:video analytic types.fall'); } },
]);

export const VIDEO_ANALYTIC_TYPES_OPTIONS = optionsProxy.create([
  ...VIDEO_ANALYTIC_TYPES_OPTIONS_BASE.raw,
  { value: 'facecover', get label() { return i18n.t('constants:video analytic types.facecover'); } },
]);

export const VIDEO_ANALYTIC_TYPES_OPTIONS_V2 = optionsProxy.create([
  ...VIDEO_ANALYTIC_TYPES_OPTIONS_BASE.raw,
  { value: 'facecover', get label() { return i18n.t('constants:video analytic types.facecoverV2'); } },
]);

export const FIRE_TYPE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:fire types.0'); } },
  { value: 1, get label() { return i18n.t('constants:fire types.1'); } },
  { value: 2, get label() { return i18n.t('constants:fire types.2'); } },
]);

export const ROLE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:user'); } },
  { value: 2, get label() { return i18n.t('constants:admin'); } },
]);

export const GENDER_OPTIONS_STRICT = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:female'); } },
  { value: 1, get label() { return i18n.t('constants:male'); } },
]);

export const GENDER_OPTIONS = optionsProxy.create([
  ...GENDER_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:not_estimated'); } },
]);

export const EVENT_OPTIONS = optionsProxy.create([
  { value: 'faces', get label() { return i18n.t('constants:faces_count'); } },
  { value: 'events', get label() { return i18n.t('constants:events_count'); } },
]);

export const OBJECT_TYPES_OPTIONS = optionsProxy.create([
  { value: 'faces', get label() { return i18n.t('constants:faces'); } },
  { value: 'events', get label() { return i18n.t('constants:events'); } },
]);

export const ETHNIC_OPTIONS = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:african_american'); }, description: 'african_american' },
  { value: 2, get label() { return i18n.t('constants:indian'); }, description: 'indian' },
  { value: 3, get label() { return i18n.t('constants:asian'); }, description: 'asian' },
  { value: 4, get label() { return i18n.t('constants:caucasian'); }, description: 'caucasian' },
  { value: 'null', get label() { return i18n.t('constants:not_estimated'); } },
]);

export const EMOTION_OPTIONS_STRICT = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:anger'); } },
  { value: 2, get label() { return i18n.t('constants:disgust'); } },
  { value: 3, get label() { return i18n.t('constants:fear'); } },
  { value: 4, get label() { return i18n.t('constants:happiness'); } },
  { value: 5, get label() { return i18n.t('constants:neutral'); } },
  { value: 6, get label() { return i18n.t('constants:sadness'); } },
  { value: 7, get label() { return i18n.t('constants:surprise'); } },
]);

export const EMOTION_OPTIONS = optionsProxy.create([
  ...EMOTION_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:not_estimated'); } },
]);

export const MASK_OPTIONS_STRICT = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:mask_states.missing'); } },
  { value: 2, get label() { return i18n.t('constants:mask_states.medical_mask'); } },
  { value: 3, get label() { return i18n.t('constants:mask_states.occluded'); } },
]);

export const MASK_OPTIONS = optionsProxy.create([
  ...MASK_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:not_estimated'); } },
]);

export const TYPE_OPTIONS = [
  { value: 'image_search', get label() { return i18n.t('constants:image_search'); } },
  { value: 'file_export', get label() { return i18n.t('constants:export_to_file'); } },
  { value: 'unknown', get label() { return i18n.t('constants:unknown'); } },
];

export const STATUS_OPTIONS = [
  { value: 0, get label() { return i18n.t('constants:pending'); } },
  { value: 1, get label() { return i18n.t('constants:launched'); } },
  { value: 2, get label() { return i18n.t('constants:done'); } },
  { value: 3, get label() { return i18n.t('constants:aborted'); } },
  { value: 4, get label() { return i18n.t('constants:canceled'); } },
];
export const TIME_TYPE_OPTIONS = optionsProxy.create([
  { value: 'sec', get label() { return i18n.t('constants:seconds'); } },
  { value: 'frames', get label() { return i18n.t('constants:frames'); } },
]);

export const CAMERA_PROTOCOL_OPTIONS = optionsProxy.create([
  { value: 'tcp', get label() { return i18n.t('constants:tcp'); } },
  { value: 'udp', get label() { return i18n.t('constants:udp'); } },
]);

export const CAMERA_ROTATION_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return 0; } },
  { value: 90, get label() { return 90; } },
  { value: 180, get label() { return 180; } },
  { value: 270, get label() { return 270; } },
]);

export const LIVENESS_MODE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:first_n_shots'); } },
  { value: 1, get label() { return i18n.t('constants:last_n_shots_before_bestshot'); } },
  { value: 2, get label() { return i18n.t('constants:all_track_shots'); } },
]);

export const CAMERA_STATUS_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:stopped'); } },
  { value: 1, get label() { return i18n.t('constants:active'); } },
  { value: 2, get label() { return i18n.t('constants:connecting'); } },
  { value: 3, get label() { return i18n.t('constants:failed'); } },
]);

export const TASKS_TYPE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:unknown'); } },
  { value: 1, get label() { return i18n.t('constants:composition'); } },
  { value: 2, get label() { return i18n.t('constants:clusterization'); } },
  { value: 3, get label() { return i18n.t('constants:report'); } },
  { value: 4, get label() { return i18n.t('constants:garbage_collecting'); } },
  { value: 5, get label() { return i18n.t('constants:re_extraction'); } },
  { value: 6, get label() { return i18n.t('constants:cross_matching'); } },
  { value: 7, get label() { return i18n.t('constants:roc_curve_calculation'); } },
  { value: 8, get label() { return i18n.t('constants:export'); } },
  { value: 9, get label() { return i18n.t('constants:batch_processing'); } },
]);

export const TASKS_STATUS_OPTIONS = [
  { value: 0, get label() { return i18n.t('constants:pending'); } },
  { value: 1, get label() { return i18n.t('constants:in_progress'); } },
  { value: 2, get label() { return i18n.t('constants:task_canceled'); } },
  { value: 3, get label() { return i18n.t('constants:error'); } },
  { value: 4, get label() { return i18n.t('constants:collecting_results'); } },
  { value: 5, get label() { return i18n.t('constants:done'); } },
];

export const DESCRIPTOR_TYPE_OPTIONS = optionsProxy.create([
  { value: 'face', get label() { return i18n.t('constants:faces'); } },
  { value: 'body', get label() { return i18n.t('constants:bodies'); } },
]);

export const MULTIFACE_POLICY_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:discard'); } },
  { value: 1, get label() { return i18n.t('constants:do_not_discard'); } },
  { value: 2, get label() { return i18n.t('constants:select_best_quality_face'); } },
]);

export const AGE_OPTIONS = optionsProxy.create([
  { value: [0, 18], get label() { return i18n.t('constants:below_18'); } },
  { value: [18, 45], get label() { return i18n.t('constants:from_18_to_44'); } },
  { value: [45, 61], get label() { return i18n.t('constants:from_45_to_60'); } },
  { value: [61, 100], get label() { return i18n.t('constants:above_60'); } },
], {
  get(target, prop) {
    if (prop === 'raw') return target;

    if (prop.includes('_')) {
      let [gte, lt] = prop.split('_');
      gte = parseFloat(gte);
      if (Number.isNaN(gte)) gte = undefined;
      lt = parseFloat(lt);
      if (Number.isNaN(lt)) lt = undefined;

      if (gte === undefined && lt === undefined) return null;

      const result = target.find(({ value }) => (
        gte === value[0] && lt === value[1]
      ));

      // eslint-disable-next-line @stylistic/max-statements-per-line
      return result ?? { value: [gte, lt], get label() { return i18n.t('other_type'); } };
    }
    const numberedProp = parseFloat(prop);
    if (Number.isNaN(numberedProp)) return null;

    const result = target.find(({ value: [gte, lt] }) => (
      numberedProp >= gte && numberedProp < lt
    ));

    return result ?? null;
  },
});

export const TEMPERATURE_OPTIONS = optionsProxy.create([
  { value: 't#normal', get label() { return i18n.t('constants:temperature.normal', { context: 'short' }); } },
  { value: 't#high', get label() { return i18n.t('constants:temperature.increased', { context: 'short' }); } },
  { value: 't#abnormal', get label() { return i18n.t('constants:temperature.abnormal', { context: 'short' }); } },
]);

export const TEMPERATURE_BY_GROUP_OPTIONS = optionsProxy.create([{
  get label() { return i18n.t('temperature'); },
  options: [
    { value: 't#normal', get label() { return i18n.t('constants:temperature.normal', { context: 'short' }); } },
    { value: 't#high', get label() { return i18n.t('constants:temperature.increased', { context: 'short' }); } },
    { value: 't#abnormal', get label() { return i18n.t('constants:temperature.abnormal', { context: 'short' }); } },
  ],
}]);

export const TEMPERATURE_TAG_OPTIONS = optionsProxy.create([
  { value: 't#normal', get label() { return i18n.t('constants:temperature.normal'); } },
  { value: 't#high', get label() { return i18n.t('constants:temperature.increased'); } },
  { value: 't#abnormal', get label() { return i18n.t('constants:temperature.abnormal'); } },
]);

export const EYE_STATUS_OPTIONS = optionsProxy.create([
  { value: 'open', get label() { return i18n.t('constants:open'); } },
  { value: 'closed', get label() { return i18n.t('constants:closed'); } },
  { value: 'occluded', get label() { return i18n.t('constants:occluded'); } },
]);

export const MOUTH_STATUS_OPTIONS = optionsProxy.create([
  { value: 'opened', get label() { return i18n.t('constants:open'); } },
  { value: 'smile', get label() { return i18n.t('constants:smile'); } },
  { value: 'occluded', get label() { return i18n.t('constants:occluded'); } },
]);

export const DEEPFAKE_STATE_OPTIONS_STRICT = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:deepfake.state.fake'); } },
  { value: 1, get label() { return i18n.t('constants:deepfake.state.real'); } },
]);
export const DEEPFAKE_STATE_OPTIONS = optionsProxy.create([
  ...DEEPFAKE_STATE_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:deepfake.state.null'); } },
]);

export const FACE_OCCLUSION_STATE_OPTIONS_STRICT = optionsProxy.create([
  { value: 'face', get label() { return i18n.t('constants:face_occlusion_state.face'); } },
  { value: 'forehead', get label() { return i18n.t('constants:face_occlusion_state.forehead'); } },
  { value: 'eye', get label() { return i18n.t('constants:face_occlusion_state.eye'); } },
  { value: 'nose', get label() { return i18n.t('constants:face_occlusion_state.nose'); } },
  { value: 'mouth', get label() { return i18n.t('constants:face_occlusion_state.mouth'); } },
  { value: 'lower_face', get label() { return i18n.t('constants:face_occlusion_state.lower_face'); } },
]);

export const DEEPFAKE_MODE_OPTIONS = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:deepfake.mode.swap'); } },
  { value: 2, get label() { return i18n.t('constants:deepfake.mode.swap+synt'); } },
]);

export const META_TYPE = optionsProxy.create([
  { value: 'string', get label() { return i18n.t('constants:meta type.string'); } },
  { value: 'integer', get label() { return i18n.t('constants:meta type.integer'); } },
  { value: 'numeric', get label() { return i18n.t('constants:meta type.numeric'); } },
]);

export const META_NUM_OPERATOR = optionsProxy.create([
  { value: 'eq', get label() { return 'eq'; } },
  { value: 'neq', get label() { return 'neq'; } },
  { value: 'in', get label() { return 'in'; } },
  { value: 'nin', get label() { return 'nin'; } },
  { value: 'gt', get label() { return 'gt'; } },
  { value: 'gte', get label() { return 'gte'; } },
  { value: 'lt', get label() { return 'lt'; } },
  { value: 'lte', get label() { return 'lte'; } },
]);

export const META_STR_OPERATOR = optionsProxy.create([
  ...META_NUM_OPERATOR.raw,
  { value: 'like', get label() { return 'like'; } },
  { value: 'nlike', get label() { return 'nlike'; } },
]);

export const STREAM_DATA_TYPE_OPTIONS = optionsProxy.create([
  { value: 'videofile', get label() { return i18n.t('constants:stream data type.videofile'); } },
  { value: 'stream', get label() { return i18n.t('constants:stream data type.stream'); } },
]);

export const TIMESTAMP_SOURCE_OPTIONS = optionsProxy.create([
  { value: 'auto', get label() { return i18n.t('constants:timestamp source.auto'); } },
  { value: 'pts', get label() { return i18n.t('constants:timestamp source.pts'); } },
  { value: 'server', get label() { return i18n.t('constants:timestamp source.server'); } },
  { value: 'frame_rate', get label() { return i18n.t('constants:timestamp source.frames'); } },
]);

export const TIME_FILTER_TYPE_OPTIONS = optionsProxy.create([
  { value: 'median', get label() { return i18n.t('constants:time filter type.median'); } },
  { value: 'min', get label() { return i18n.t('constants:time filter type.min'); } },
]);

export const NOTIFICATION_TYPE_OPTIONS = optionsProxy.create([
  { value: 'videoanalytics', get label() { return i18n.t('constants:notifications.type.videoanalytics'); } },
  { value: 'events', get label() { return i18n.t('constants:notifications.type.events'); } },
]);
